import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SurveyResultsFilterNames } from 'models';
import { IFilterChangePayload } from 'modules/admin-panel/pages/results/models';
import {
	getFromSessionStorage,
	SessionStorageKeyTypes,
} from 'utils/clientStorage';
import {
	calculatedRoundsSelector,
	statisticGroupingTypeSelector,
} from 'modules/admin-panel/pages/results/selectors/dashboard.selectors';
import { setActiveService } from 'modules/admin-panel/pages/results/results.actions';
import { useSurveyResultsFilter } from '../useSurveyResultsFilter';

interface IFilterServicePayload extends IFilterChangePayload {
	isServicePage?: boolean;
}

export const useSetActiveService = (isServicePage?: boolean) => {
	const dispatch = useDispatch();
	const {
		onChangeSurveyResultsFilter,
		surveyFilter,
	} = useSurveyResultsFilter();
	const surveyId = getFromSessionStorage(
		SessionStorageKeyTypes.dashboardSurveyId,
	);
	const rounds = useSelector(calculatedRoundsSelector);
	const groupingType = useSelector(statisticGroupingTypeSelector);

	const boundSetActiveService = useCallback(
		(p: IFilterServicePayload) => dispatch(setActiveService(p)),
		[dispatch],
	);

	return useCallback(
		(curServiceId?: number) => {
			boundSetActiveService({
				rounds,
				surveyId,
				...surveyFilter,
				serviceId: (curServiceId as number | string) || '',
				groupingType,
				isServicePage,
			});
			onChangeSurveyResultsFilter({
				[SurveyResultsFilterNames.serviceId]: curServiceId?.toString(),
			});
		},
		[
			boundSetActiveService,
			surveyId,
			rounds,
			groupingType,
			onChangeSurveyResultsFilter,
			surveyFilter,
			isServicePage,
		],
	);
};
